import React from "react";
import { CSSTransition } from "react-transition-group";
import { CopyToClipboard } from "react-copy-to-clipboard";
import Dialog from "../../../../../lib/Dialog";

export default function PackAlert({ visible, code, onClose }) {
  return (
    <CSSTransition in={visible} timeout={250} unmountOnExit>
      <div className="im-pack-alert">
        <div className="im-pack-mask" onClick={onClose} />
        <div className="im-pack-container">
          <div className="title">恭喜获得群聊入群礼包！</div>
          <div className="pack">{code}</div>
          <CopyToClipboard
            text={code}
            onCopy={() => Dialog.info("已复制礼包码，可前往我的礼包查看！")}
          >
            <div className="done" onClick={onClose}>
              我知道了
            </div>
          </CopyToClipboard>
        </div>
      </div>
    </CSSTransition>
  );
}
